import {
  getAccessLogOutput,
  getBarcodeArchiveProcessList,
  getBarcodeAttachedFileList,
  getBarcodeExport,
  getBarcodeExportMO,
  getLocationExportList,
  getMasterDataExport,
} from '@/utils/api'

import {
  LOAD_ACESS_LOG_EXPORT_LIST,
  LOAD_BARCODE_ARCHIVE_LIST,
  LOAD_BARCODE_ATTACHED_FILE_LIST,
  LOAD_BARCODE_EXPORT_LIST,
  LOAD_EXPORT_LIST,
  LOAD_LOCATION_EXPORT_LIST,
  LOAD_MASTER_EXPORT_LIST,
  LOAD_BULK_REPORT_MO_EXPORT_LIST,
  SET_HAVE_NEW_EXPORT_RECORD,
} from './actions'
import { EExportType } from '@/utils/enums'
import {
  IAccessLogResponse,
  IBarcodeExportHistoryResponse,
  IBarcodeExportResponse,
  IExportPaginationParams,
  ILocationResponse,
  IMasterDataExportResponse,
} from '@/utils/types'

export interface IExportState {
  haveNew: number
  total: number
  data: (
    | IBarcodeExportResponse
    | IAccessLogResponse
    | ILocationResponse
    | IMasterDataExportResponse
    | IBarcodeExportHistoryResponse
  )[]
}

const DEFAULT_PROCESSING_RECORDS = { haveNew: 0, data: [], total: 0 }

type TExportStates = {
  [EExportType.BARCODE]: IExportState
  [EExportType.MASTER_DATA]: IExportState
  [EExportType.ACCESS_LOG]: IExportState
  [EExportType.LOCATION]: IExportState
  [EExportType.ARCHIVE]: IExportState
  [EExportType.FILE]: IExportState
  [EExportType.BULK_REPORT_MO]: IExportState
}

export default {
  state: {
    [EExportType.BARCODE]: { ...DEFAULT_PROCESSING_RECORDS },
    [EExportType.MASTER_DATA]: { ...DEFAULT_PROCESSING_RECORDS },
    [EExportType.ACCESS_LOG]: { ...DEFAULT_PROCESSING_RECORDS },
    [EExportType.LOCATION]: { ...DEFAULT_PROCESSING_RECORDS },
    [EExportType.ARCHIVE]: { ...DEFAULT_PROCESSING_RECORDS },
    [EExportType.FILE]: { ...DEFAULT_PROCESSING_RECORDS },
    [EExportType.BULK_REPORT_MO]: { ...DEFAULT_PROCESSING_RECORDS },
  },
  mutations: {
    [LOAD_EXPORT_LIST]: (
      state: TExportStates,
      {
        exportType,
        data,
        total,
      }: {
        exportType: EExportType
        data: (
          | IBarcodeExportResponse
          | IAccessLogResponse
          | ILocationResponse
          | IMasterDataExportResponse
          | IBarcodeExportHistoryResponse
        )[]
        total: number
      }
    ) => {
      state[exportType] = { haveNew: 0, data, total }
    },
    [SET_HAVE_NEW_EXPORT_RECORD]: (
      state: TExportStates,
      {
        exportType,
        isHaveNew,
      }: {
        exportType: EExportType
        isHaveNew: boolean
      }
    ) => {
      state[exportType].haveNew = isHaveNew ? state[exportType].haveNew + 1 : 0
    },
  },
  actions: {
    [LOAD_BARCODE_EXPORT_LIST]: async ({ commit }: { commit: Function }, data: IExportPaginationParams) => {
      let exportData = { exportType: EExportType.BARCODE, data: [], total: 0 }
      try {
        const { barcodeExportHistories, count } = await getBarcodeExportMO(data)
        exportData = { ...exportData, data: barcodeExportHistories, total: count }
      } catch (err) {}
      commit(LOAD_EXPORT_LIST, exportData)
    },

    [LOAD_MASTER_EXPORT_LIST]: async ({ commit }: { commit: Function }, data: IExportPaginationParams) => {
      let exportData = { exportType: EExportType.MASTER_DATA, data: [], total: 0 }
      try {
        const { exportHistories, total } = await getMasterDataExport(data)
        exportData = { ...exportData, data: exportHistories, total }
      } catch (err) {}
      commit(LOAD_EXPORT_LIST, exportData)
    },

    [LOAD_BULK_REPORT_MO_EXPORT_LIST]: async ({ commit }: { commit: Function }, data: IExportPaginationParams) => {
      let exportData = { exportType: EExportType.BULK_REPORT_MO, data: [], total: 0 }
      try {
        const { barcodeExportHistories, total } = await getBarcodeExportMO(data)
        exportData = { ...exportData, data: barcodeExportHistories, total }
      } catch (err) {}
      commit(LOAD_EXPORT_LIST, exportData)
    },
    [LOAD_ACESS_LOG_EXPORT_LIST]: async ({ commit }: { commit: Function }, data: IExportPaginationParams) => {
      let exportData = { exportType: EExportType.ACCESS_LOG, data: [], total: 0 }
      try {
        const { logExports, count } = await getAccessLogOutput(data)
        exportData = { ...exportData, data: logExports, total: count }
      } catch (err) {}
      commit(LOAD_EXPORT_LIST, exportData)
    },
    [LOAD_BARCODE_ATTACHED_FILE_LIST]: async ({ commit }: { commit: Function }, data: IExportPaginationParams) => {
      let exportData = { exportType: EExportType.FILE, data: [], total: 0 }
      try {
        const { barcodeExports, count } = await getBarcodeAttachedFileList(data)
        exportData = { ...exportData, data: barcodeExports, total: count }
      } catch (err) {}
      commit(LOAD_EXPORT_LIST, exportData)
    },
    [LOAD_LOCATION_EXPORT_LIST]: async ({ commit }: { commit: Function }, data: IExportPaginationParams) => {
      let exportData = { exportType: EExportType.LOCATION, data: [], total: 0 }
      try {
        const { barcodeExports, count } = await getLocationExportList(data)
        exportData = { ...exportData, data: barcodeExports, total: count }
      } catch (err) {}
      commit(LOAD_EXPORT_LIST, exportData)
    },
    [LOAD_BARCODE_ARCHIVE_LIST]: async ({ commit }: { commit: Function }, data: IExportPaginationParams) => {
      let exportData = { exportType: EExportType.ARCHIVE, data: [], total: 0 }
      try {
        const { barcodeArchives, count } = await getBarcodeArchiveProcessList(data)
        exportData = { ...exportData, data: barcodeArchives, total: count }
      } catch (err) {}
      commit(LOAD_EXPORT_LIST, exportData)
    },
  },
}
